import {
  AiFillHome,
  AiFillInfoCircle,
  AiFillProject,
  AiOutlineAntDesign,
  AiOutlineHome,
  AiOutlineSelect,
  AiTwotoneProject,
} from "react-icons/ai";
import { BsFillInfoCircleFill, BsPeopleFill } from "react-icons/bs";
import { GoChevronRight, GoProject } from "react-icons/go";
import {
  FaBars,
  FaBloggerB,
  FaCcVisa,
  FaImages,
  FaNewspaper,
  FaPeopleCarry,
  FaProjectDiagram,
  FaThList,
  FaUserFriends,
} from "react-icons/fa";
import { GiThink } from "react-icons/gi";
import {
  MdContacts,
  MdContentPaste,
  MdManageAccounts,
  MdOutlineContentPaste,
  MdOutlineManageAccounts,
  MdOutlineMiscellaneousServices,
  MdOutlinePeopleAlt,
  MdPersonSearch,
  MdWork,
} from "react-icons/md";
import { RiGalleryFill, RiListSettingsFill, RiTeamFill } from "react-icons/ri";
import { SiOpenaigym } from "react-icons/si";
import { TiThListOutline } from "react-icons/ti";
import { TbCertificate } from "react-icons/tb";

export const RoutePath = {
  homeBanner: "homepage/banner",
  homeAbout: "homepage/who-we-are",
  homePartners: "homepage/hiring-partners",
  homePartnersAdd: "homepage/hiring-partners/add-new",
  homeProjects: "homepage/ongoing-projects",
  homeCounter: "homepage/counter",
  homeSubsidaries: "homepage/business-subsidaries",

  aboutUs: "about-us/content",
  // aboutUsCertificates: "about-us/certificates",
  aboutUsCertificateContent: "about-us/certificates-content",
  aboutUsCertificateList: "about-us/certificates-list",
  dynamicAboutUsCertificateList: "about-us/certificates-list/:certificateId",
  aboutUsCertificateListAdd: "about-us/certificates-list/add-new",
  // aboutUsBoard: "about-us/board-of-directors",
  aboutUsBoardContent: "about-us/bod-content",
  aboutUsBoardList: "about-us/bod-list",
  aboutUsBoardListAdd: "about-us/bod-list/add-new",
  dynamicAboutUsBoardList: "about-us/bod-list/:id",
  // aboutUsManagements: "about-us/managements",
  aboutUsManagementsContent: "about-us/management-content",
  aboutUsManagementsList: "about-us/management-list",
  aboutUsManagementsListAdd: "about-us/management-list/add-new",
  dynamicAboutUsManagements: "about-us/management-list/:id",
  aboutUsNews: "about-us/news-events",
  aboutUsNewsAdd: "about-us/news-events/add-new",
  dynamicAboutUsNews: "about-us/news-events/:id",
  aboutUsBusinessSubs: "about-us/business-subsidaries",
  aboutUsBusinessSubsAdd: "about-us/business-subsidaries/add-new",
  aboutUsGalleries: "about-us/gallery",
  aboutUsGalleriesAdd: "about-us/gallery/add-new",
  aboutUsCareerContent: "about-us/career-content",
  aboutUsCareerList: "about-us/career-list",
  aboutUsCareerListAdd: "about-us/career-list/add-new",
  dynamicAboutUsCareerList: "about-us/career-list/:id",
  // our-services
  servicesWorkforceContent: "services/workforce-solutions/content",
  servicesWorkforceList: "services/workforce-solutions/list",
  servicesWorkforceListAdd: "services/workforce-solutions/list/add-new",
  dynamicWorkforceList: "services/workforce-solutions/list/:id",
  servicesTraining: "services/training",
  servicesVisa: "services/visa",
  // selection
  selectionBanner: "selection/banner",
  selectionContent: "selection/content",
  selectionContentAdd: "selection/content/add-new",
  dynamicSelectionContent: "selection/content/:id",
  // projects
  projectsBanner: "ongoing-projects/banner",
  projectsContent: "ongoing-projects/content",
  projectsContentAdd: "ongoing-projects/content/add-new",
  dynamicProjectsContent: "ongoing-projects/content/:id",
  // jobs
  jobsBanner: "jobs/banner",
  jobsContent: "jobs/content",
  jobsContentAdd: "jobs/content/add-new",
  dynamicJobsContent: "jobs/content/:id",
  // contacts
  contactBanner: "contacts/banner",
  contactContent: "contacts/content",
  contactList: "contacts/list",
  contactListAdd: "contacts/list/add-new",
  dynamicContactList: "contacts/list/:id",
  login: "login",
  userList: "user/list",
  // userCreate: "user/create",
  // userProfile: "user/profile",
};

export const apiPath = {
  homeApi: "home-pages",
  aboutUsApi: "about-us",
  certificateApi: "certificates",
  boardApi: "board-of-directors",
  managementsApi: "managements",
  newsAndEventsApi: "news-and-events",
  galleriesApi: "galleries",
  careersApi: "careers",
  workforceApi: "workforce-solutions",
  trainingApi: "training",
  visaApi: "visa",
  selectionApi: "selections",
  projectsApi: "ongoing-projects",
  jobsApi: "jobs",
  contactApi: "contacts",
  userListApi: "user/list",
};

export const sideBarNavigation = [
  {
    title: "Home pages",
    url: "#",
    icon: <AiFillHome />,
    subUrl: [
      {
        title: "banner",
        url: "homepage/banner",
        icon: <AiOutlineAntDesign />,
      },
      {
        title: "who we are",
        url: "homepage/who-we-are",
        icon: <AiOutlineAntDesign />,
      },
      {
        title: "hiring partners",
        url: "homepage/hiring-partners",
        icon: <AiOutlineAntDesign />,
      },
      {
        title: "ongoing projects",
        url: "homepage/ongoing-projects",
        icon: <AiOutlineAntDesign />,
      },
      {
        title: "counter",
        url: "homepage/counter",
        icon: <AiOutlineAntDesign />,
      },
      // {
      //   title: "business subsidiaries",
      //   url: "homepage/business-subsidaries",
      //   icon: <AiOutlineAntDesign />,
      // },
    ],
  },
  {
    title: "About Us",
    url: "#",
    icon: <AiFillInfoCircle />,
    subUrl: [
      {
        title: "About Us",
        url: "about-us/content",
        icon: <AiFillInfoCircle />,
      },
      /* {
        title: "Certificates",
        url: "#",
        icon: <TbCertificate />,
        subUrl: [
          {
            title: "Certificates Content",
            url: "about-us/certificates-content",
            icon: <AiOutlineAntDesign />,
          },
          {
            title: "Certificates List",
            url: "about-us/certificates-list",
            icon: <AiOutlineAntDesign />,
          },
        ],
      },
      {
        title: "Board of Directors",
        url: "#",
        icon: <BsPeopleFill />,
        subUrl: [
          {
            title: "BOD. Content",
            url: "about-us/bod-content",
            icon: <AiOutlineAntDesign />,
          },
          {
            title: "BOD. List",
            url: "about-us/bod-list",
            icon: <AiOutlineAntDesign />,
          },
        ],
      }, */
      {
        title: "Managements",
        url: "#",
        icon: <MdManageAccounts />,
        subUrl: [
          {
            title: "Management Content",
            url: "about-us/management-content",
            icon: <AiOutlineAntDesign />,
          },
          {
            title: "Management List",
            url: "about-us/management-list",
            icon: <AiOutlineAntDesign />,
          },
        ],
      },
      {
        title: "business subsidiaries",
        url: "about-us/business-subsidaries",
        icon: <AiOutlineAntDesign />,
      },
      {
        title: "News and Events",
        url: "about-us/news-events",
        icon: <FaNewspaper />,
      },
      {
        title: "Galleries",
        url: "about-us/gallery",
        icon: <FaImages />,
      },
      {
        title: "Careers",
        url: "#",
        icon: <FaPeopleCarry />,
        subUrl: [
          {
            title: "career Content",
            url: "about-us/career-content",
            icon: <AiOutlineAntDesign />,
          },
          {
            title: "career List",
            url: "about-us/career-list",
            icon: <AiOutlineAntDesign />,
          },
        ],
      },
    ],
  },

  {
    title: "Our Services",
    url: "#",
    icon: <MdWork />,
    subUrl: [
      {
        title: "Workforce Solution",
        url: "#",
        icon: <MdWork />,
        subUrl: [
          {
            title: "workforce Content",
            url: "services/workforce-solutions/content",
            icon: <AiOutlineAntDesign />,
          },
          {
            title: "workforce List",
            url: "services/workforce-solutions/list",
            icon: <AiOutlineAntDesign />,
          },
        ],
      },
      {
        title: "Testing & Training",
        url: "services/training",
        icon: <SiOpenaigym />,
      },
      {
        title: "Visa Processing & Legal Services",
        url: "services/visa",
        icon: <FaCcVisa />,
      },
    ],
  },
  {
    title: "Selection process",
    url: "#",
    icon: <AiOutlineSelect />,
    subUrl: [
      {
        title: "banner",
        url: "selection/banner",
        icon: <AiOutlineAntDesign />,
      },
      {
        title: "content",
        url: "selection/content",
        icon: <AiOutlineAntDesign />,
      },
    ],
  },

  {
    title: "Projects",
    url: "#",
    icon: <AiFillProject />,
    subUrl: [
      {
        title: "All Projects",
        url: "#",
        icon: <GoProject />,
        subUrl: [
          {
            title: "banner",
            url: "ongoing-projects/banner",
            icon: <AiOutlineAntDesign />,
          },
          {
            title: "content",
            url: "ongoing-projects/content",
            icon: <AiOutlineAntDesign />,
          },
        ],
      },
      {
        title: "Available Jobs",
        url: "#",
        icon: <MdWork />,
        subUrl: [
          {
            title: "banner",
            url: "jobs/banner",
            icon: <AiOutlineAntDesign />,
          },
          {
            title: "content",
            url: "jobs/content",
            icon: <AiOutlineAntDesign />,
          },
        ],
      },
    ],
  },
  {
    title: "Contact",
    url: "#",
    icon: <MdContacts />,
    subUrl: [
      {
        title: "banner",
        url: "contacts/banner",
        icon: <AiOutlineAntDesign />,
      },
      {
        title: "REACH US",
        url: "contacts/content",
        icon: <AiOutlineAntDesign />,
      },
      {
        title: "Our offices",
        url: "contacts/list",
        icon: <AiOutlineAntDesign />,
      },
    ],
  },
];

export const clientSideUrl = {
  clientHome: "https://innoviaengineering.com",
  clientAbout: "https://innoviaengineering.com/about",
  clientCertificate: "https://innoviaengineering.com/certificate",
  clientDirectors: "https://innoviaengineering.com/directors",
  clientManagement: "https://innoviaengineering.com/management-team",
  clientNews: "https://innoviaengineering.com/news",
  clientGallery: "https://innoviaengineering.com/gallery",
  clientCareer: "https://innoviaengineering.com/career",
  clientServices: "https://innoviaengineering.com/services",
  clientTraining: "https://innoviaengineering.com/training",
  clientVisa: "https://innoviaengineering.com/visa",
  clientSelection: "https://innoviaengineering.com/selection",
  clientOngoingProjects: "https://innoviaengineering.com/ongoing-projects",
  clientJobs: "https://innoviaengineering.com/jobs",
  clientContact: "https://innoviaengineering.com/contact",
};

export const getToken = () => {
  const tempToken = sessionStorage.getItem("ebc202c5c66c906f41dfee622fb64223")
    ? sessionStorage.getItem("ebc202c5c66c906f41dfee622fb64223")
    : "1234";

  return decryptToken(tempToken);
};

export const decryptToken = (tempToken) => {
  let charPlace = tempToken.indexOf(".");
  let payLoad = tempToken.slice(0, charPlace + 1);
  let legitToken = tempToken.slice(charPlace + 11);
  return payLoad + legitToken;
};
